import { isRequiredCurrency } from 'utils/validators';

const validate = values => {
  const errors = {};

  if (values.days && values.days.length) {
    const days = values.days;
    const daysErrors = [];

    days.forEach((day, dayIndex) => {
      if (isRequiredCurrency(day)) {
        daysErrors[dayIndex] = {
          USD: 'Error',
          EUR: 'Error',
          NOK: 'Error'
        };
      }
    });

    if (daysErrors.length) {
      errors.days = {
        ...daysErrors,
        _error: {
          ...daysErrors.map(
            () => 'Value for at least one currency should be filled in'
          )
        }
      };
    }
  }

  return errors;
};

export default validate;
